/**
 * Created by anatoly on 28.08.2024
 */

const DangerAnimationView = cc.Node.extend({
    ctor: function (component) {
        this._super();

        this.component = component;

        this.bg = new cc.Sprite(bundles.danger_component.frames.bg_room);
        this.bg.setAlignment(cleverapps.styles.DangerAnimation.bg);

        this.addChild(this.bg, -1);

        this.setContentSize(this.bg.getContentSize());
        this.setAnchorPoint(0.5, 0.5);

        this.addHero();
        this.addDrillAnimation();

        this.onResize();

        component.on("onStart", this.startAnimation.bind(this));
        component.on("onStop", this.stopDrill.bind(this));
    },

    addDrillAnimation: function () {
        const styles = cleverapps.styles.DangerAnimation.drills;

        this.drillWall = new cc.Sprite(bundles.danger_component.frames.block);

        this.addChild(this.drillWall);

        this.drills = [];

        for (let i = 0; i < DangerAnimationView.DRILLS_COUNT; i++) {
            const drill = new cleverapps.Spine(bundles.danger_component.jsons.drill);
            drill.setAnimation(0, "idle", true);

            this.drills.push(drill);
        }

        this.drillsLayout = new cleverapps.Layout(this.drills, {
            margin: styles.margin
        });
        this.drillsLayout.setAlignment(styles);

        this.drillWall.addChild(this.drillsLayout);
    },

    addHero: function () {
        const styles = cleverapps.styles.DangerAnimation.hero;

        const person = cleverapps.persons.getRole(styles.personCode);
        const hero = this.hero = new cleverapps.Spine(person.json);
        hero.setAnimation(0, "idle_tricky", true);

        this.component.on("onNoMuchTime", () => {
            hero.setAnimation(0, "scared", true);
        });

        this.addChild(hero, -1);
    },

    startAnimation: function () {
        this.hero.setAnimationAndIdleAfter("start", "idle_tricky");
        this.startDrillAnimation();

        this.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.CallFunc(() => {
                    this.drillSound = cleverapps.effects.fire("danger.tricky.drill");
                }),
                new cc.DelayTime(8)
            )
        ));
    },

    setDrillsStopAnimation: function () {
        this.drills.forEach((drill) => {
            drill.setAnimation(0, "stop");
        });

        cleverapps.effects.fire("danger.tricky.drill.win");
    },

    getDrillEndXPosition: function () {
        const hero = this.hero;

        return hero.getPosition().x
            + hero.width / 2 * hero.scale
            + (this.drillWall.width + this.drillsLayout.width) / 2 * this.drillWall.scale
            - this.drillsLayout.getPosition().x * this.drillWall.scale;
    },

    startDrillAnimation: function () {
        if (this.component.stopped) {
            return;
        }

        const timeLeft = this.component.getTimeLeft();

        this.drillWall.runAction(new cc.MoveTo(timeLeft / 1000, this.getDrillEndXPosition(), this.drillWall.y));
    },

    onWin: function () {
        this.setDrillsStopAnimation();
        this.hero.setAnimation(0, "joy", true);

        this.hero.runAction(new cc.Sequence(
            cleverapps.effects.fireAction("danger.tricky.applause"),
            new cc.DelayTime(2),
            new cc.CallFunc(() => {
                this.removeHero();
            })
        ));
    },

    onLose: function () {
        this.hero.setAnimation(0, "disappear", false);
        this.hero.runAction(new cc.Sequence(
            new cc.DelayTime(2),
            new cc.CallFunc(() => {
                this.removeHero();
            })
        ));
    },

    removeHero: function () {
        this.hero.runAction(new cc.Sequence(
            new cc.MoveTo(0.4, cc.p((-this.hero.width * this.hero.scale) / 2, this.hero.y)).easing(cc.easeIn(2)),
            new cc.RemoveSelf()
        ));
    },

    getPartFromScreen: function () {
        return cleverapps.styles.DangerAnimation.partFromScreen[cleverapps.resolution.mode];
    },

    onResize: function () {
        const bgRect = cleverapps.resolution.getBgRect();
        const partFromScreen = this.getPartFromScreen();

        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            const totalWidth = bgRect.width * partFromScreen;
            this.setScale(Math.min(totalWidth / this.width, bgRect.height / this.height));
        } else {
            const totalHeight = bgRect.height * partFromScreen;
            this.setScale(Math.min(totalHeight / this.height, bgRect.width / this.width));
        }

        const styles = cleverapps.styles.DangerAnimation;

        const sceneRect = cleverapps.resolution.getSceneSize();

        let position;
        if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
            position = cc.p(sceneRect.width * this.getPartFromScreen() / 2, sceneRect.height / 2);
        } else {
            position = cc.p(sceneRect.width / 2, sceneRect.height * (1 - this.getPartFromScreen()) + sceneRect.height * this.getPartFromScreen() / 2);
        }

        const offsets = styles.offsets[cleverapps.resolution.mode];
        this.setPosition(cc.pAdd(position, offsets));

        this.hero.setScale(styles.hero.scale);
        this.hero.setAlignment(styles.hero);

        this.drillWall.setAlignment(this.width - this.drillWall.width / 2, this.drillWall.height / 2);
    },

    hide: function (f) {
        const scale = this.getScale();

        this.runAction(
            new cc.ScaleTo(0.3, scale * 0.5).easing(cc.easeBackIn()).setFinalize(() => {
                this.setVisible(false);
                f();
            })
        );
    },

    stopDrill: function () {
        this.stopAllActions();
        this.drillWall.stopAllActions();

        cleverapps.audio.stopSound(this.drillSound);
    }
});

DangerAnimationView.DRILLS_COUNT = 3;

cleverapps.styles.DangerAnimation = {
    partFromScreen: [0.4, 0.4, 0.55],

    bg: {
        x: { align: "center" },
        y: { align: "center" }
    },

    offsets: [
        { x: 0, y: 0 },
        { x: 0, y: 0 },
        { x: 0, y: -60 }
    ],

    positions: [
        {
            x: { align: "center" },
            y: { align: "top" }
        },
        {
            x: { align: "center" },
            y: { align: "top" }
        },
        {
            x: { align: "left" },
            y: { align: "center" }
        }
    ],

    hero: {
        x: { align: "left", dx: 100 },
        y: { align: "bottom", dy: 110 },

        scale: 0.8,
        personCode: "yellow"
    },

    drills: {
        x: { align: "center", dx: -105 },
        y: { align: "center", dy: 25 },

        margin: 40
    }
};